// Generated by Melange

import NcalayerclientJs from "./ncalayerclient.js";
import * as Curry from "melange.js/curry.js";
import * as Json__Json_decode from "melange-json/Json_decode.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";

function make(prim) {
  return new NcalayerclientJs(prim);
}

function unwrapResponse(resp) {
  const json = JSON.parse(resp);
  const status = Json__Json_decode.field("status", (function (param) {
          return Json__Json_decode.optional(Json__Json_decode.bool, param);
        }), json);
  if (status !== undefined) {
    if (status) {
      return {
              TAG: /* Ok */0,
              _0: {
                body: Json__Json_decode.field("body", Json__Json_decode.string, json)
              }
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: {
                code: Json__Json_decode.field("code", Json__Json_decode.string, json),
                message: Json__Json_decode.field("message", Json__Json_decode.string, json)
              }
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              code: "qweqrt",
              message: "qweqw"
            }
          };
  }
}

function send(client, payload) {
  return $$Promise.exec(function (resolve) {
              client.send(payload, (function (param) {
                      return Curry._1(resolve, unwrapResponse(param));
                    }));
            });
}

function sendWithArgs(client, args) {
  const payload = {
    module: "com.buhta.cert.ncamodule",
    method: "call",
    args: args
  };
  return send(client, payload);
}

function cleanPublicCert(cert) {
  return cert.slice(28, -27).replace(/(?:\r\n|\r|\n)/g, "");
}

export {
  make ,
  unwrapResponse ,
  send ,
  sendWithArgs ,
  cleanPublicCert ,
}
/* ./ncalayerclient.js Not a pure module */
